import React from 'react';
import ProductCategoryTable from '../../../components/ProductMasters/ProductCategory/ProductCategoryTable';
import ContentView from '../../../components/Layouts/ContentView';
const index = () => {
    return (
        <ContentView>
            <ProductCategoryTable />
        </ContentView>
    );
};
export default index;
